import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";
import { Validacao } from "features/projetos/models/Validacao";

async function fetchValidacao(projetoId: string): Promise<IResponse<Validacao>> {
    return await axios.get(`/Validacao/${projetoId}`);
}

export default fetchValidacao;